import { persistor, store } from './store';
import rootReducer from './rootReducer';

export const injectSlice = ((
  ...args: Parameters<typeof rootReducer.inject>
) => {
  const injected = rootReducer.inject(...args);

  store.replaceReducer(injected);
  persistor.persist();

  return injected;
}) as typeof rootReducer.inject;
